import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation  } from 'react-router-dom';

import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';


function TreeSubscription() {
  
 const navigate = useNavigate();
 const location = useLocation();
  
  const queryParams = new URLSearchParams(location.search);
  const verifyCode = queryParams.get("verifyCode");


  const { data: userCode, isLoadingCode, isErrorCode } = useQuery({
    queryKey: ["user-code", verifyCode], // ✅ include in cache key
    queryFn: () =>
      axios
        .get(`${API_URL}/tree-subscription-check-code-api?verifyCode=${verifyCode}`, { 
          withCredentials: true 
        })
        .then((response) => response.data),
    enabled: !!verifyCode, //only run if verifyCode exists
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: "always",
  refetchOnWindowFocus: "always",
  });

  
  
  const { data: plans, isLoading, isError } = useQuery({
    queryKey: ["subscription-plans"],
    queryFn: () =>
      axios
        .get(`${API_URL}/tree-subscription-plans-api`, { withCredentials: true })
        .then((response) => response.data),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: "always",
  refetchOnWindowFocus: "always",
  });



  if (isLoading) return <div className="loadingspinnerDiv">
  <div className="loadingspinner"></div>
</div>;
  if (isError) return <p>Error fetching plans</p>;

  return (
    

    <div className='main-wrapper'>
          <div className='content container-fluid'>
    

    {userCode?.Status === "Success" ? (
  <>
    <p className="subscription-title">
      Hello {userCode.user.name} {userCode.user.last_name}, kindly select your subscription plan
    </p>

    <div className="plans-grid">
      {Array.isArray(plans) && plans.length > 0 ? (
        plans.map((plan) => (
          <div
            key={plan.id}
            className={`plan-card ${plan.recommended ? "recommended" : ""}`}
          >
            {plan.recommended && <div className="badge">Popular</div>}

            <h3 className="plan-title">{plan.title}</h3>

            <div className="plan-price">
              <span>KES {plan.price}</span>
              <small> / {plan.period}</small>
            </div>

            <ul className="plan-features">
              {Array.isArray(plan.features) ? (
                plan.features.map((f, idx) => <li key={idx}>{f}</li>)
              ) : (
                <li>{plan.features}</li>
              )}
            </ul>

            <button
              onClick={() =>
                navigate("/tree-subscription-now", {
                  state: { planId_name: plan.id, verifyCode: verifyCode },
                })
              }
              className={`subscribe-btn ${
                plan.recommended ? "primary" : "secondary"
              }`}
            >
              {plan.cta}
            </button>
          </div>
        ))
      ) : (
        <p>No subscription plans found</p>
      )}
    </div>
  </>
) : (
  
  <div
  className="d-flex justify-content-center align-items-center" >
<div
    className="card shadow-lg text-center p-5 mt-4"
    style={{ maxWidth: "500px", borderRadius: "0px" }}
  >
    {/* Warning Icon */}
    <div className="mb-4">
      <div
        className="d-inline-flex align-items-center justify-content-center rounded-circle"
        style={{
          width: "70px",
          height: "70px",
          backgroundColor: "#ffe6e6",
        }}
      >
         
        <i className="fa fa-exclamation-triangle text-danger fs-2"></i>
      </div>
    </div>

    {/* Title */}
    <h3 className="fw-bold text-danger">Link Expired</h3>

    {/* Message */}
    <p className="text-muted mt-3">
      Sorry, the link has expired. Kindly resend the notification to continue.
    </p>

    </div>
  </div>

)}

<div className='row mt-4' style={{marginTop: '5%'}}></div>


        </div>
        </div>
  );
}

export default TreeSubscription;
